import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export default function FreeTrialEndedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-6 py-20">
      <h4 className="text-xl font-semibold">Your free trial period has ended</h4>
      <p className="text-muted-foreground">Purchase Premium</p>
      <Button onClick={() => navigate('/in/account/billing')}>Billing</Button>
    </div>
  );
}
